import React, { useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../../services/api';
import { Brain, Search, CheckCircle, Loader2 } from 'lucide-react';
import { useAuth } from '../../store/AuthContext';

const AIMarketAnalysis = ({ token }) => {
  const { setUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState('');

  const handleAnalize = async () => {
    setLoading(true);
    setError('');
    try {
      const resp = await axios.get(`${getApiUrl()}/ai/analyze-market/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setResults(resp.data.data);
      
      // Refresh user profile to get the new missionProfile
      const userResp = await axios.get(`${getApiUrl()}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(userResp.data.data.user);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al analizar mercado');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      background: 'rgba(5, 7, 10, 0.9)', 
      border: '1px solid #0B3D91',
      padding: '15px',
      borderRadius: '4px',
      color: '#F0F0F0',
      width: '280px',
      boxShadow: '0 0 20px rgba(0,0,0,0.5)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', gap: '8px' }}>
        <Brain size={18} color="#E27B58" />
        <h3 style={{ 
          color: '#E27B58', 
          fontSize: '0.85rem', 
          margin: 0,
          textTransform: 'uppercase', 
          letterSpacing: '1px' 
        }}>
          AI MARKET INTEL
        </h3>
      </div>

      {!results ? (
        <>
          <p style={{ fontSize: '0.75rem', color: '#AAA', marginBottom: '15px' }}>
            Generar lista de competidores y motores complementarios basada en tu perfil.
          </p>
          <button 
            className="nasa-button" 
            style={{ width: '100%', fontSize: '0.75rem' }}
            onClick={handleAnalize}
            disabled={loading}
          >
            {loading ? 'ANALIZANDO...' : 'INICIAR ANÁLISIS IA'}
          </button>
          {error && <p style={{ color: '#ff7675', fontSize: '11px', marginTop: '10px' }}>{error}</p>}
        </>
      ) : (
        <div style={{ maxHeight: '400px', overflowY: 'auto', paddingRight: '5px' }}>
          <div style={{ marginBottom: '15px' }}>
            <h4 style={{ fontSize: '0.75rem', color: '#00CEC9', marginBottom: '8px', borderBottom: '1px solid #333' }}>
              COMPETENCIA DIRECTA
            </h4>
            <ul style={{ paddingLeft: '15px', margin: 0 }}>
              {results.competence.map((c, idx) => (
                <li key={idx} style={{ fontSize: '0.75rem', marginBottom: '4px', opacity: 0.8 }}>{c}</li>
              ))}
            </ul>
          </div>
          
          <div style={{ marginBottom: '15px' }}>
            <h4 style={{ fontSize: '0.75rem', color: '#FDCB6E', marginBottom: '8px', borderBottom: '1px solid #333' }}>
              MOTORES (ENGINES)
            </h4>
            <ul style={{ paddingLeft: '15px', margin: 0 }}>
              {results.engines.map((e, idx) => (
                <li key={idx} style={{ fontSize: '0.75rem', marginBottom: '4px', opacity: 0.8 }}>{e}</li>
              ))}
            </ul>
          </div>

          <div style={{ fontSize: '10px', color: '#666', marginTop: '10px', textAlign: 'center' }}>
            Contexto: {results.brand} | {results.country}
          </div>

          <button 
            className="nasa-button" 
            style={{ width: '100%', marginTop: '15px', fontSize: '0.7rem', borderColor: '#333' }}
            onClick={() => setResults(null)}
          >
            NUEVA CONSULTA
          </button>
        </div>
      )}
    </div>
  );
};

export default AIMarketAnalysis;
